import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from 'components/common/Button';
import { Box, Divider } from '@material-ui/core';
import Form from 'components/form';
import CheckboxGroup from 'components/form/CheckboxGroup';
import { toUserTimezone } from 'utils';


const FormItem = Form.FormItem;

const MeetingFeedbackModal = ({
  onClose,
  onSubmit,
  options,
  task,
  student,
  form: { getFieldDecorator, validateFields },
}) => {
  const [value, setValue] = useState('');

  const handleSubmit = () => {
    return validateFields().then((values) => {
      values = { ...values, meeting_summary: value, completed_at: toUserTimezone(new Date())};
      return onSubmit(values);
    });
  };

  return (
    <Dialog open onClose={onClose} disableBackdropClick>
      <DialogTitle>Meeting Summary</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Write a brief summary of this meeting, including what the student
          worked on, whether they are on track, and what major items they are
          working on next. This summary will be sent to the student's guardians.
        </DialogContentText>
        <Box>
          <TextField
            multiline
            placeholder="Enter your summary here..."
            variant="outlined"
            rows={6}
            rowsMin={6}
            autoFocus
            fullWidth
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </Box>
      </DialogContent>
      <Divider />
      {task.status === 'done' &&
        (student.product_type === 'core' || student.product_type === 'pro') && (
          <>
            <DialogTitle>Meeting Attendees</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Select the names of anyone who attended the meeting, even only
                for part of the time.
              </DialogContentText>
              <Form>
                <FormItem>
                  {getFieldDecorator('meeting_attendees', {
                    initialValue: null,
                    rules: [
                      {
                        required: true,
                        message: 'Please select attendees',
                      },
                    ],
                  })(
                    <CheckboxGroup
                      style={{ width: 'max-content' }}
                      options={options}
                    />,
                  )}
                </FormItem>
              </Form>
            </DialogContent>{' '}
          </>
        )}
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={!value}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Form.create()(MeetingFeedbackModal);
